





































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import QuickTable from "../../../../../components/table/table.vue";
import Tools from '../../../../../lib/tools';
@Component({
	name:'safetyPunishment',
	components: {
		QuickTable
	}
})
export default class SafetyPunishment extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
		personData: [],			// 人员数据
		organizations: [],		// 部门数据
		formData: {
			punishDepId: '',
			punishUserId: '',
			punishDt: '',
			workPlace: '',
			punishReason: '',
			auditUserId: '',
			punishDetail: '',
			remark: ''
		},
		validate: {
			punishDepId: [
				{ required: true, type: 'number', message: '请选择被处罚部门', trigger: 'change' }
			],
			punishUserId: [
				{ required: true, type: 'number', message: '请选择被处罚人', trigger: 'change' }
			],
			punishReason: [
				{ required: true, message: '请填写处罚原因', trigger: 'blur' }
			]
		},
		datepickerOption: {
            disabledDate (date:any) {
                return date && date.valueOf() > Date.now();
            }
        },
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '部门',
				key: 'punishDep',
				render: (h:any, params:any) => {
					return h('span', (params.row.punishDep ? params.row.punishDep.displayName : ''));
				}
			},
			{
				title: '姓名',
				key: 'punishUser',
				render: (h:any, params:any) => {
					return h('span', (params.row.punishUser ? params.row.punishUser.name : ''));
				}
			},
			{
				title: '时间',
				key: 'punishDt',
				render: (h:any, params:any) => {
					return h('span', Tools.formatDate(params.row.punishDt));
				}
			},
			{
				title: '工作岗位',
				key: 'workPlace'
			},
			{
				title: '处罚原因',
				key: 'punishReason'
			},
			{
				title: '批准人',
				key: 'auditUser',
				render: (h:any, params:any) => {
					return h('span', (params.row.auditUser ? params.row.auditUser.name : ''));
				}
			},
			{
				title: '事后（四不放过）处理情况',
				key: 'punishDetail'
			},
			{
				title: '备注',
				key: 'remark'
			}
		]
	}
	// 初始化
    init() {
    	// 获取部门信息
    	this.$store.dispatch('project/GetbearerOrg').then(() => {
    		this.initData.organizations = this.$store.state.project.bearerOrgId;
    	})
    	// 获取所有人员信息
    	this.$store.dispatch('project/GetAllPersons').then(() => {
    		this.initData.personData = this.$store.state.project.allPersons;
    	})
    }
    // 新增人员
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
            	let params:any = {
					punishDt: Tools.formatDate(datas.punishDt),
					punishDepId: datas.punishDepId,
					punishUserId: datas.punishUserId,
					workPlace: datas.workPlace,
					punishReason: datas.punishReason,
					auditUserId: datas.auditUserId,
					punishDetail: datas.punishDetail,
					remark: datas.remark
				}
            	this.initData.formLoading = true;
                await Ajax.post('/api/services/app/SafetyProduct/CreatePunishAsync', params).then((res:any)=>{
	                this.$Message.success('提交成功!');
	                this.initData.formLoading = false;
	                this.initData.showModal = false;
                	(this as any).$refs.table.GetData();
	            }).catch(() => {
	            	this.initData.formLoading = false;
	            })
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		(this as any).$refs.form.resetFields();
    	}
    }
    mounted() {
    	this.init();
    }
}
